import { Controller } from "@hotwired/stimulus"

// Shows and hides a block from a button that stays in place.
// Usage:
//   <div data-controller="disclosure">
//     <button type="button" aria-expanded="false" data-disclosure-target="button" data-action="disclosure#toggle">…</button>
//     <div hidden data-disclosure-target="content">…</div>
//   </div>
export default class extends Controller {
  static targets = ["button", "content"]

  toggle() {
    const open = this.contentTarget.hidden
    this.contentTarget.hidden = !open
    this.buttonTarget.setAttribute("aria-expanded", String(open))
  }
}
